var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185 62.88",
    style: {
      enableBackground: "new 0 0 185 62.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1D1D1D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.82,38.05H13.91v24.83H0V0.97h13.91v24.13h13.91V0.97h13.91v61.9H27.82V38.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.59,44.79c0,3.96,1.46,5.84,5.15,5.84h0.35v13.21h-2.57c-11.27,0-16.83-5.56-16.83-17.87v-28.1 C48.68,5.56,54.25,0,65.51,0h2.57v13.22h-0.35c-3.69,0-5.15,1.88-5.15,5.84V44.79z M76.5,19.06c0-3.97-1.46-5.84-5.15-5.84h-0.35 V0h2.57c11.27,0,16.83,5.56,16.83,17.88v28.1c0,12.31-5.56,17.87-16.83,17.87h-2.57V50.64h0.35c3.69,0,5.15-1.88,5.15-5.84V19.06z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.14,62.88h-14.61V38.05L92.5,0.97h13.91l10.43,25.11l10.43-25.11h13.91l-17.04,37.07V62.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.61,37.63h6.4l-4.66-25.11l-9.39,50.36H137.7l13.21-61.9h20.87L185,62.88h-14.26l-2.3-12.31h-11.27 L159.61,37.63z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3bc605ac97b47e1884c8a7d4417dba1d.svg";
export { ForwardRef as ReactComponent };